import { render } from "./TranscoderManage.vue?vue&type=template&id=15b74078"
import script from "./TranscoderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscoderManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TranscoderDash/TranscoderManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15b74078"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15b74078', __exports__)) {
    api.reload('15b74078', __exports__)
  }
  
  module.hot.accept("./TranscoderManage.vue?vue&type=template&id=15b74078", () => {
    api.rerender('15b74078', render)
  })

}


export default __exports__